import React from 'react';
import { MapPin, Clock, Home, Trees } from 'lucide-react';

const StudioSection: React.FC = () => {
  return (
    <section id="studio" className="relative py-20 overflow-hidden">
      {/* Background Image with Parallax */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-fixed"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1540497077202-7c8a3999166f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')`,
        }}
      >
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      <div className="relative container mx-auto px-6">
        <h2 className="font-bebas text-5xl md:text-7xl text-center text-white mb-16 tracking-wider">
          THE <span className="text-primary">STUDIO</span>
        </h2>

        <div className="max-w-4xl mx-auto text-center text-white">
          <p className="font-montserrat text-lg mb-12 leading-relaxed">
            Our Training Studio is a private training space designed for those who value results, 
            focus, and a personalized experience. Unlike crowded gyms, our studio offers a calm, 
            exclusive environment where every workout is tailored to your goals.
          </p>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {/* Main Studio Location */}
            <div className="bg-black/50 backdrop-blur-sm p-8">
              <MapPin className="text-primary mx-auto mb-4" size={32} />
              <h3 className="font-bebas text-2xl mb-4 tracking-wider">STUDIO ADDRESS</h3>
              <p className="font-montserrat text-lg mb-2">1019 El Camino Real</p>
              <p className="font-montserrat text-lg">Menlo Park, CA 94025</p>
            </div>

            {/* Hours */}
            <div className="bg-black/50 backdrop-blur-sm p-8">
              <Clock className="text-primary mx-auto mb-4" size={32} />
              <h3 className="font-bebas text-2xl mb-4 tracking-wider">HOURS</h3>
              <p className="font-montserrat">MONDAY - FRIDAY</p>
              <p className="font-montserrat text-lg mb-2">6:30AM - 7:00PM</p>
              <p className="font-montserrat mt-4">SATURDAY - SUNDAY</p>
              <p className="font-montserrat text-lg">By Appointment</p>
            </div>
          </div>

          {/* Additional Service Areas */}
          <div className="bg-black/50 backdrop-blur-sm p-8">
            <h3 className="font-bebas text-3xl mb-6 tracking-wider text-primary">
              WE ALSO SERVE
            </h3>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div className="flex items-center justify-center">
                <Home className="text-primary mr-3" size={24} />
                <div className="text-left">
                  <p className="font-montserrat font-semibold">HOME GYM TRAINING</p>
                  <p className="text-gray-300 text-sm font-montserrat">
                    Personalized sessions at your location
                  </p>
                </div>
              </div>
              
              <div className="flex items-center justify-center">
                <Trees className="text-primary mr-3" size={24} />
                <div className="text-left">
                  <p className="font-montserrat font-semibold">OUTDOOR TRAINING</p>
                  <p className="text-gray-300 text-sm font-montserrat">
                    Fresh air workouts in nature
                  </p>
                </div>
              </div>
            </div>

            <p className="font-montserrat text-gray-300 mt-6">
              Serving clients throughout Menlo Park, Palo Alto, and Los Altos Area
            </p>
          </div>

          <button 
            onClick={() => {
              const element = document.querySelector('#booking');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="mt-8 bg-primary hover:bg-red-600 text-white font-montserrat font-bold px-8 py-4 text-lg tracking-wider transition-all duration-300 transform hover:scale-105"
          >
            BOOK YOUR SESSION
          </button>
        </div>
      </div>
    </section>
  );
};

export default StudioSection;